const paramsKeys = {
  PROMOCODE: 'code',
  APP_IDENTITY: 'app-identity',
  OTC_CODE: 'otc-code',
  ERROR: 'error',
  ERROR_MESSAGE: 'err_message',
  PERMANENT_TOKEN: 'permanent_access_token',
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  DIIA_CALLBACK_URL: 'diia_success_url',
  DIIA_SUCCESS_URL: 'diia_success_url',
  PROFILE_SECTION: 'section', // pre-select section at /profile

  // change-email flow params
  TOKEN: 'token',
  EMAIL: 'email',
  PROFILE_NOTIFICATION: 'profile_notif',

  PLAN: 'plan',
  REGISTRATION_SOURCE: 'registration_source',
  ADD_NEW_DEVICE: 'add_new_device',

  TV_CONNECTED: 'tv-connected', // opens up the TV connected modal
  DOWNLOAD_MODAL_SLIDE: 'slide', // pre-select slide in DownloadModal

  // trackings
  FUNNEL: 'funnel',
  CLICK_ID: 'clickid',
  IR_CLICK_ID: 'irclickid',
  UTM_SOURCE: 'utm_source',
  UTM_MEDIUM: 'utm_medium',
  UTM_CAMPAIGN: 'utm_campaign',
  AD_SET: 'ad_set',
  SHORTCUT: 'shortcut',
  AD_GROUP_ID: 'adgroupid',

  // query analytics
  CID: 'cid',
  PRODUCT: 'product',
  BUNDLE: 'bundle',
  VERSION: 'version',
  OS: 'os',
  LANG: 'lang',
  PLATFORM: 'platform',
};

const getParsedParams = (): Record<keyof typeof paramsKeys, string | null> => {
  const params = new URLSearchParams(window.location.search);

  return Object.entries(paramsKeys).reduce((acc: Record<string, string | null>, entry) => {
    const [key, value] = entry;

    acc[key] = params.get(value);

    return acc;
  }, {});
};

export { paramsKeys, getParsedParams };
